import {NextAppointmentView} from "@/medication-checkup/interfaces/next-appointment";
import {SceneProps, useScene} from "@/medication-checkup/composables/useScene";

/**
 * What the scenes of the next appointment share, at the end of a step held
 * with the patient.
 *
 * The card lands a beat after the bubble, and stays live once the block is
 * completed: booking, moving and canceling the appointment are agenda calls,
 * not submissions of the block. The one submission is the quick reply that
 * moves on — « Continuer » once an appointment is booked, « Prévoir plus
 * tard » while none is — served by the handler as the actions of the block.
 */
export const useNextAppointmentScene = (props: SceneProps<NextAppointmentView>) => {
    const {bubbleShown, cardShown, clicked, view, text, actions, acted, act} = useScene(props, {card: true});

    return {bubbleShown, cardShown, clicked, view, text, actions, acted, act};
};
